import api from './api';
import { FilterPreset, RidesQuery } from '../types';

export const fetchFilterPresets = async (): Promise<FilterPreset[]> => {
  const response = await api.get('/api/driver/filter-presets');
  return response.data.presets || [];
};

export const createFilterPreset = async (
  name: string,
  query: Partial<RidesQuery>,
): Promise<FilterPreset> => {
  const response = await api.post('/api/driver/filter-presets', { name, query });
  return response.data.preset;
};

export const updateFilterPreset = async (
  id: string,
  body: { name?: string; query?: Partial<RidesQuery> },
): Promise<FilterPreset> => {
  const response = await api.put(`/api/driver/filter-presets/${id}`, body);
  return response.data.preset;
};

export const deleteFilterPreset = async (id: string): Promise<void> => {
  await api.delete(`/api/driver/filter-presets/${id}`);
};
